import { useOutletContext } from "react-router-dom";
import { Alert } from "@dealer-center/core-components";
import type { ControlcenterAPIInterfaceExternal } from "@dealer-center/ddc-pages-controlcenter-interface";
import type { decodedJwtAndPermissions } from "@dealer-center/ddc-api-user-interface";
import { Locale } from "@dealer-center/ddc-core-utils";
import LABELS from "./labels.json";
import { getURLparameter } from "./utils/utils";
import "./AccountAssets.scss";
import { GetPresigned } from "./components/GetPresigned";

export const AccountAssets = (): React.ReactElement => {
  const path = getURLparameter("path") || "dealerphoto";
  const { ccUserInfo, userEntity } = useOutletContext<{
    ccUserInfo: ControlcenterAPIInterfaceExternal;
    userEntity: decodedJwtAndPermissions;
  }>();

  Locale.setLabelsOnce(LABELS);

  if (userEntity.internal && ccUserInfo.accountId === "ddc") {
    return (
      <Alert role="alert" sx={{ marginBottom: "16px" }} type="error">
        {Locale.getText("ACCOUNTASSETS_NO_ACCESS") as string}
      </Alert>
    );
  }

  return (
    <div className="account-assets-container">
      <GetPresigned path={path} />
    </div>
  );
};
